<template>

    <i v-if="!documentStatus" class="fas fa-lg fa-fw"></i>

    <!-- Authorization -->
    <i v-else-if="documentStatus.id == DocumentStatus.AUTHORIZATION_NEW" class="fas fa-lg fa-fw" :title="documentStatus.name"></i>
    <i v-else-if="documentStatus.id == DocumentStatus.AUTHORIZATION_SUBMITTING" class="fas fa-spinner fa-spin fa-lg fa-fw text-secondary"></i>
    <i v-else-if="documentStatus.id == DocumentStatus.AUTHORIZATION_SUBMIT_FAILED" class="fas fa-exclamation-circle fa-lg fa-fw text-danger" :title="documentStatus.name"></i>
    <i v-else-if="documentStatus.id == DocumentStatus.AUTHORIZATION_SUBMITTED" class="fas fa-clock fa-lg fa-fw text-primary cursor-pointer" @click="setResponse()" :title="documentStatus.name"></i>
    <i v-else-if="documentStatus.id == DocumentStatus.AUTHORIZATION_ADDITIONAL_INFO_REQUESTED" class="fas fa-plus-square fa-lg fa-fw text-warning" :title="documentStatus.name"></i>
    <i v-else-if="documentStatus.id == DocumentStatus.AUTHORIZATION_APPROVED" class="fas fa-thumbs-up fa-lg fa-fw text-success cursor-pointer" @click="setResponse()" :title="documentStatus.name"></i>
    <i v-else-if="documentStatus.id == DocumentStatus.AUTHORIZATION_APPROVED_WITH_MODIFICATIONS" class="fas fa-thumbs-up fa-lg fa-fw text-secondary cursor-pointer" @click="setResponse()" :title="documentStatus.name"></i>
    <i v-else-if="documentStatus.id == DocumentStatus.AUTHORIZATION_DENIED" class="fas fa-thumbs-down fa-lg fa-fw text-danger cursor-pointer" @click="setResponse()" :title="documentStatus.name"></i>
    <i v-else-if="documentStatus.id == DocumentStatus.AUTHORIZATION_RESPONSE_OVERDUE" class="fas fa-clock fa-lg fa-fw text-danger cursor-pointer" @click="setResponse()" :title="documentStatus.name"></i>

    <!-- Authorization Disputes -->
    <i v-else-if="documentStatus.id == DocumentStatus.AUTHORIZATION_DISPUTE_NEW" class="fas fa-lg fa-fw" :title="documentStatus.name"></i>
    <i v-else-if="documentStatus.id == DocumentStatus.AUTHORIZATION_DISPUTE_SUBMITTING" class="fas fa-spinner fa-spin fa-lg fa-fw text-secondary"></i>
    <i v-else-if="documentStatus.id == DocumentStatus.AUTHORIZATION_DISPUTE_SUBMIT_FAILED" class="fas fa-exclamation-circle fa-lg fa-fw text-danger" :title="documentStatus.name"></i>
    <i v-else-if="documentStatus.id == DocumentStatus.AUTHORIZATION_DISPUTE_SUBMITTED" class="fas fa-clock fa-lg fa-fw text-primary cursor-pointer" :title="documentStatus.name" @click="setResponse()"></i>
    <i v-else-if="documentStatus.id == DocumentStatus.AUTHORIZATION_DISPUTE_APPROVED" class="fas fa-thumbs-up fa-lg fa-fw text-success cursor-pointer cursor-pointer" :title="documentStatus.name" @click="setResponse()"></i>
    <i v-else-if="documentStatus.id == DocumentStatus.AUTHORIZATION_DISPUTE_DENIED" class="fas fa-thumbs-down fa-lg fa-fw text-danger cursor-pointer cursor-pointer" :title="documentStatus.name" @click="setResponse()"></i>
    <i v-else-if="documentStatus.id == DocumentStatus.AUTHORIZATION_DISPUTE_RESPONSE_OVERDUE" class="fas fa-clock fa-lg fa-fw text-danger cursor-pointer" @click="setResponse()" :title="documentStatus.name"></i>

    <!-- Claims Services -->
    <i v-else-if="documentStatus.id == DocumentStatus.CLAIM_NEW" class="fas fa-lg fa-fw" :title="documentStatus.name"></i>
    <i v-else-if="documentStatus.id == DocumentStatus.CLAIM_SUBMITTING" class="fas fa-spinner fa-spin fa-lg fa-fw text-secondary"></i>
    <i v-else-if="documentStatus.id == DocumentStatus.CLAIM_SUBMIT_FAILED" class="fas fa-exclamation-circle fa-lg fa-fw text-danger" :title="documentStatus.name"></i>  
    <i v-else-if="documentStatus.id == DocumentStatus.CLAIM_SUBMITTED" class="fas fa-clock fa-lg fa-fw text-primary" :title="documentStatus.name"></i>
    <payment-icon v-else-if="documentStatus.id == DocumentStatus.CLAIM_PAID" class="text-success" :title="documentStatus.name"></payment-icon>
    <payment-icon v-else-if="documentStatus.id == DocumentStatus.CLAIM_UNDERPAID" class="text-danger" :title="documentStatus.name"></payment-icon>
    <payment-icon v-else-if="documentStatus.id == DocumentStatus.CLAIM_OVERPAID" class="text-warning" :title="documentStatus.name"></payment-icon>
    <i v-else-if="documentStatus.id == DocumentStatus.CLAIM_PAYMENT_OVERDUE" class="fas fa-clock fa-lg fa-fw text-danger" :title="documentStatus.name"></i>
    <i v-else-if="documentStatus.id == DocumentStatus.CLAIM_DISPUTED" class="fas fa-exclamation-triangle text-warning fa-lg fa-fw" :title="documentStatus.name"></i>

    <i v-else class="fas fa-lg fa-fw"></i>
</template>

<script>
import { DocumentType, DocumentStatus } from '../../constants';
import PaymentIcon from '../icons/PaymentIconComponent.vue';

export default {
    components: {
        PaymentIcon,
    },
    props: {
        documentId: Number,
        documentTypeId: {
            type: Number,
            required: false
        },
        documentStatus: Object,
    },
    data() {
        return {

            // import constants class
            DocumentType,
            DocumentStatus
        }
    },
    methods: {
        setResponse: function () {
            if (this.documentTypeId) {
                if (this.documentTypeId == DocumentType.LWC_FORM_1010) {
                    eventHub.$emit('show-authorization-response', this.documentId);
                }
                else if (this.documentTypeId == DocumentType.LWC_FORM_1009) {
                    eventHub.$emit('show-dispute-response', this.documentId);
                }
            }
        },
    },
}
</script>

<style scoped>
    .fa-exclamation-triangle.text-warning {
        background:linear-gradient(#555,#555) center bottom/20% 84% no-repeat;
    }

    .fa-plus-square.text-warning {
        background:linear-gradient(#555,#555) center no-repeat;
    }   
</style>